import api from "utils/api";

export const postAddToCart = async (params) => {
    try {
        const res = await api.post(`/buccl_user/cart/`, params);
        return res.data;
    } catch (err) {
        throw err;
    }
};

export const getUserCartList = async () => {
    try {
        const res = await api.get(`/buccl_user/cart/`);
        return res.data;
    } catch (err) {
        throw err;
    }
};

export const deleteUserCart = async (itemId) => {
    try {
        const res = await api.delete(`/buccl_user/cart/${itemId}/`);
        return res.data;
    } catch (err) {
        throw err;
    }
};

/**
 * 장바구니 다건 삭제 - 단건 삭제 API를 반복 호출한다.
 * 하나가 실패해도 나머지 처리 결과를 파악할 수 있도록 Promise.allSettled를 사용한다.
 * @param {Array<number|string>} itemIds - 삭제할 장바구니 아이템 ID 목록
 * @returns {Promise<{succeededIds: Array, failedIds: Array}>} - 성공/실패 ID 목록
 */
export const deleteUserCartItems = async (itemIds) => {
    const results = await Promise.allSettled(
        itemIds.map((itemId) => deleteUserCart(itemId))
    );

    const succeededIds = [];
    const failedIds = [];

    results.forEach((result, index) => {
        if (result.status === "fulfilled") {
            succeededIds.push(itemIds[index]);
        } else {
            console.error("장바구니 삭제 실패:", itemIds[index], result.reason);
            failedIds.push(itemIds[index]);
        }
    });

    return { succeededIds, failedIds };
};

export const updateUserCartQuantity = async (itemId, quantity) => {
    try {
        const res = await api.patch(`/buccl_user/cart/${itemId}/`, {
            quantity,
        });
        return res.data;
    } catch (err) {
        throw err;
    }
};

/**
 *
 * @param {Object} params - 결제 파라미터
 * @param {number} params.buyer_name - 주문자 이름
 * @param {number} params.buyer_tel - 주문자 전화번호
 * @param {number} params.buyer_email - 주문자 이메일
 * @param {number} params.cart_item_ids - 상품 ID [1,2,3]
 * @param {string} params.shipping_address - 배송지 주소 (기본 주소 + 상세 주소)
 * @param {string} params.shipping_zip_code - 배송지 우편번호
 * @param {string} [params.shipping_memo] - 배송 메시지. 주문의 shipping_info.shipping_memo 로 저장된다.
 * @returns {Object} - 결제 정보
 */
export const postPaymentAllCartItems = async (params) => {
    try {
        const res = await api.post(`/buccl_user/cart/checkout/`, params);
        return res.data;
    } catch (err) {
        throw err;
    }
};

export const getDeliveryFee = async (params) => {
    try {
        const res = await api.post(
            `/buccl_user/cart/calculate-shipping/`,
            params
        );
        return res.data;
    } catch (err) {
        throw err;
    }
};
